import { main } from "./main"

class Pagination {
  constructor() {
    const self = this
    if ($(".js-pagination .pagination").length) {
      $(window).on("scroll", function () {
        const rawUrl = $(".pagination .js-next_page").attr("href")

        if (rawUrl && self.approachingBottom()) {
          $(".pagination").html(main.bootstrapSpinner("left: 0"))

          return $.getScript(rawUrl)
        }
      })
      $(window).trigger("scroll")
      return
    }
  }

  approachingBottom() {
    return (
      $(window).scrollTop() >
      $(document).height() - $(window).height() - $(window).height()
    )
  }
}

export { Pagination }
